import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Clock, User, CalendarDays } from 'lucide-react';
import { BlogPost } from '@/lib/blogData';

interface BlogPostHeaderProps {
  post: BlogPost;
  readTime: number;
}

export const BlogPostHeader: React.FC<BlogPostHeaderProps> = ({ post, readTime }) => {
    return (
        <div className="relative pt-24 pb-12 md:pt-32 md:pb-20 bg-muted/10 border-b border-border">
           <div className="container px-4 max-w-4xl mx-auto text-center">
              <Link to="/blog" className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-primary transition-colors mb-8 group">
                <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" /> Back to Blog
              </Link>
              
              <div className="flex items-center justify-center gap-3 mb-6">
                 <Badge variant="secondary" className="bg-primary/10 text-primary hover:bg-primary/20 border-none px-3 py-1">
                    {post.category}
                 </Badge>
                 <span className="flex items-center text-xs font-medium text-muted-foreground uppercase tracking-wider">
                    <Clock size={12} className="mr-1" /> {readTime} min read
                 </span>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-8 leading-[1.15]">
                {post.title}
              </h1>

              <div className="flex items-center justify-center gap-4 md:gap-8 border-t border-border/50 pt-8 max-w-xl mx-auto">
                  <div className="flex items-center gap-3 text-left">
                      <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center">
                        <User size={20} className="text-muted-foreground" />
                      </div>
                      <div>
                          <div className="text-sm font-bold text-foreground">RunOffTrack</div>
                          <div className="text-xs text-muted-foreground">Publisher</div>
                      </div>
                  </div>
                  <div className="h-8 w-px bg-border/50"></div>
                  <div className="text-left">
                      <div className="text-sm font-bold text-foreground flex items-center gap-2">
                        <CalendarDays size={16} className="text-primary" />
                        {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </div>
                      <div className="text-xs text-muted-foreground">Published</div>
                  </div>
              </div>
           </div>
        </div>
    );
};
